<template>
  <div>
    <v-dialog v-model="dialog" v-if="emp" max-width="700px">
      <v-card class="emp-details">
        <v-card-title>
          <img :src="emp.img || require('@/assets/imgs/no-img21.png')" />
          <v-row class="flex-column ml-3">
            <span class="d-flex justify-space-between">
              <span class="headline-1">{{ emp.name }}</span>
              <span class="headline-4">{{ emp.cId }}</span>
            </span>
            <span class="headline-2">{{ emp.department }} - {{ emp.post }}</span>
            <span class="headline-4">{{ emp.farm }}</span>
          </v-row>
        </v-card-title>
        <v-card-text class="pb-0">
          <v-row>
            <v-col cols="2" sm="2" class="font-weight-bold pb-0">
              <span>DPI</span>
            </v-col>
            <v-col cols="4" sm="4" class="text-left pb-0">
              <span>{{ emp.dpi }}</span>
            </v-col>
            <v-col cols="3" sm="3" class="pl-0 pr-1 font-weight-bold pb-0">
              <span>Cuenta Bancaria</span>
            </v-col>
            <v-col cols="3" sm="3" class="text-left pb-0">
              <span>{{ emp.bankAcc }}</span>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="4" sm="3" class="font-weight-bold">
              <span>Total Horas</span>
            </v-col>
            <v-col cols="2" sm="3" class="">
              <span>{{ emp.extraHours }}</span>
            </v-col>
            <v-col cols="3" sm="3" class="pl-0 pr-1 font-weight-bold">
              <span>Total Dias</span>
            </v-col>
            <v-col cols="3" sm="3" class="">
              <span>{{ emp.totalDays }}</span>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="6" sm="6" class="pb-0 font-weight-bold">Salario Nomina</v-col>
            <v-col cols="6" sm="6" class="px-0 pb-0 font-weight-bold">Salario Ayco</v-col>
          </v-row>
          <v-row>
            <v-col cols="3" sm="3" class="pb-0 font-weight-medium">
              <span>Diario</span>
            </v-col>
            <v-col cols="3" sm="3" class="pb-0 px-0">
              <span>{{ formatMoney(emp.salaryNomina) }}</span>
            </v-col>
            <v-col cols="3" sm="3" class="pb-0 px-0 font-weight-medium">
              <span>Diario</span>
            </v-col>
            <v-col cols="3" sm="3" class="pb-0 px-0">
              <span>{{ formatMoney(emp.salaryAyco) }}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3" sm="3" class="font-weight-medium">
              <span>Hora Extra</span>
            </v-col>
            <v-col cols="3" sm="3" class="px-0">
              <span>{{ formatMoney(emp.hourNomina) }}</span>
            </v-col>
            <v-col cols="3" sm="3" class="px-0 font-weight-medium">
              <span>Hora Extra</span>
            </v-col>
            <v-col cols="3" sm="3" class="px-0">
              <span>{{ formatMoney(emp.hourAyco) }}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3" sm="3" class="pb-0 font-weight-medium">
              <span>Mensual</span>
            </v-col>
            <v-col cols="3" sm="3" class="pb-0 px-0">
              <span>{{ formatMoney(emp.monthlySalaryNomina) }}</span>
            </v-col>
            <v-col cols="3" sm="3" class="pb-0 px-0 font-weight-medium">
              <span>Mensual</span>
            </v-col>
            <v-col cols="3" sm="3" class="pb-0 px-0">
              <span>{{ formatMoney(emp.monthlySalaryAyco) }}</span>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="3" sm="3" class="pb-0 font-weight-medium">
              <span>Monto Quincenal</span>
            </v-col>
            <v-col cols="3" sm="3" class="pb-0 px-0">
              <span>{{ formatMoney(emp.monthSalaryNomina) }}</span>
            </v-col>
            <v-col cols="3" sm="3" class="pb-0 px-0 font-weight-medium">
              <span>Monto Quincenal</span>
            </v-col>
            <v-col cols="3" sm="3" class="pb-0 px-0">
              <span>{{ formatMoney(emp.monthSalaryAyco) }}</span>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="3" sm="3" class="pb-0 font-weight-medium">
              <span>Extras</span>
            </v-col>
            <v-col cols="3" sm="3" class="pb-0 px-0">
              <span>{{ formatMoney(emp.extraValueNomina) }}</span>
            </v-col>
            <v-col cols="3" sm="3" class="pb-0 px-0 font-weight-medium">
              <span>Extras</span>
            </v-col>
            <v-col cols="3" sm="3" class="pb-0 px-0">
              <span>{{ formatMoney(emp.extraValueAyco) }}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3" sm="3" class="pb-0 font-weight-medium">
              <span>Total a recibir</span>
            </v-col>
            <v-col cols="3" sm="3" class="pb-0 px-0">
              <span>{{ formatMoney(emp.totalSalaryNomina) }}</span>
            </v-col>
            <v-col cols="3" sm="3" class="px-0 font-weight-medium">
              <span>Total a recibir</span>
            </v-col>
            <v-col cols="3" sm="3" class="px-0">
              <span>{{ formatMoney(emp.totalSalaryAyco) }}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="5" class="py-0">
              <v-text-field dense :disabled="!loggedinUser.isEditor" name="bonus" type="number" label="Otros Ingresos"
                hide-details :value="emp.disc.bonus && emp.disc.bonus.amount" v-debounce:300ms="onSetDisc">
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="pb-0 font-weight-bold">Descuentos de Tienda</v-col>
          </v-row>
          <v-row>
            <v-col cols="6" sm="4" class="pb-0">
              <v-text-field dense :disabled="!loggedinUser.isEditor" name="sanJose" label="San Jose" type="number"
                hide-details :value="emp.shop.sanJose && emp.shop.sanJose.amount" v-debounce:300ms="onSetShop">
              </v-text-field>
            </v-col>
            <v-col cols="6" sm="4" class="pb-0">
              <v-text-field dense :disabled="!loggedinUser.isEditor" name="elPaso" label="El Paso" type="number"
                hide-details :value="emp.shop.elPaso && emp.shop.elPaso.amount" v-debounce:300ms="onSetShop">
              </v-text-field>
            </v-col>
            <v-col cols="6" sm="4" class="pb-0">
              <v-text-field dense :disabled="!loggedinUser.isEditor" hide-details type="number" label="San Jorge"
                name="sanJorge" :value="emp.shop.sanJorge && emp.shop.sanJorge.amount"
                v-debounce:300ms="onSetShop"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="pb-0 font-weight-bold">Descuentos de Prestamo</v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="4" class="">
              <v-text-field dense :disabled="!loggedinUser.isEditor" label="Anticipio" name="loan" hide-details
                :value="emp.disc.loan && emp.disc.loan.amount" v-debounce:300ms="onSetDisc"></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" class="">
              <v-text-field dense :disabled="!loggedinUser.isEditor" name="record" type="number"
                label="Antecedentes Penales" hide-details :value="emp.disc.record && emp.disc.record.amount"
                v-debounce:300ms="onSetDisc">
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="4" class="">
              <v-text-field dense :disabled="!loggedinUser.isEditor" name="wallet" type="number"
                label="Tarjeta Monedero" hide-details :value="emp.disc.wallet && emp.disc.wallet.amount"
                v-debounce:300ms="onSetDisc">
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" class="">
              <v-text-field dense :disabled="!loggedinUser.isEditor" name="health" type="number"
                label="Tarjeta de salud y pulmones" hide-details :value="emp.disc.health && emp.disc.health.amount"
                v-debounce:300ms="onSetDisc">
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3" sm="3" class="pb-0 font-weight-medium">
              <span>Total Descuentos</span>
            </v-col>
            <v-col cols="3" sm="3" class="pb-0 px-0">
              <span>{{ formatMoney(emp.totalDisc) }}</span>
            </v-col>
            <v-col cols="3" sm="3" class="px-0 font-weight-medium">
              <span>Liquido a Recibir</span>
            </v-col>
            <v-col cols="3" sm="3" class="px-0">
              <span>{{ formatMoney(emp.total) }}</span>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="pt-0">
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="onClose">Salir</v-btn>
          <v-btn color="blue darken-1" text @click="onPrintReport">Constancia de Pago</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div v-if="emp" class="print-container" ref="empReport">
      <div class="report-container">
        <emp-report class="dense" :emp="emp" :filterBy="filterBy" />
        <emp-report class="dense" :emp="emp" :filterBy="filterBy" :isCopy="true" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { formatMoney } from '@/services/utils'
import EmpReport from './EmpReport.vue';
import { printElement } from '../services/utils';
export default {
  data() {
    return {
      dialog: true
    }
  },
  created() {
    this.formatMoney = formatMoney
  },
  computed: {
    ...mapGetters('report', ['reports', 'filterBy']),
    ...mapGetters('user', ['loggedinUser']),
    emp() {
      return this.reports.find(emp => emp._id === this.empId)
    },
    empId() {
      return this.$route.params.id
    },
  },
  methods: {
    onClose() {
      this.dialog = false
      this.$router.push('./')
    },
    onPrintReport() {
      printElement(this.$refs.empReport)
      window.print()
    },
    onSetShop(amount, { target }) {
      const name = target.name
      var shop = this.emp.shop[name] && JSON.parse(JSON.stringify(this.emp.shop[name]))
      if (!shop) {
        shop = { name, amount: +amount, empId: this.emp._id }
        const createdAt = new Date(this.filterBy.date)
        this.filterBy.era === 1 ? createdAt.setUTCDate(15) : createdAt.setUTCDate(30)
        shop.createdAt = createdAt
      } else shop.amount = +amount
      this.$store.dispatch({ type: 'report/saveShop', shop })
    },
    onSetDisc(amount, { target }) {
      var disc = this.emp.disc[target.name] && JSON.parse(JSON.stringify(this.emp.disc[target.name]))
      if (!disc) {
        disc = { empId: this.emp._id, amount: +amount, name: target.name }
        const createdAt = new Date(this.filterBy.date)
        this.filterBy.era === 1 ? createdAt.setUTCDate(15) : createdAt.setUTCDate(30)
        disc.createdAt = createdAt
      } else {
        disc.amount = +amount
      }
      this.$store.dispatch({ type: 'report/saveDisc', disc })
    }
  },
  watch: {
    dialog(val) {
      val || this.onClose()
    }
  },
  components: {
    EmpReport
  }
}
</script>
